import { Injectable } from "@angular/core";
import { BehaviorSubject, distinctUntilChanged, filter, map, Observable, shareReplay, switchMap } from "rxjs";
import { ModuloResponse } from "../../dtos/core/modulo/ModuloResponse";
import { ModuloService } from "../../services/core/modulo/modulo.service";
import { ExternalAuthService } from "../../services/auth/external-auth/external-auth.service";
import { ExternalToken } from "../../dtos/core/auth/ExternalToken";

@Injectable({ providedIn: 'root' })
export class ModuloContextService {

  readonly modulos$: Observable<ModuloResponse[]>;

  constructor(
    private moduloService: ModuloService,
    private externalAuthService: ExternalAuthService
  ) {
    this.modulos$ = this.externalAuthService.currentCliente.pipe(
      filter((token): token is ExternalToken => !!token),

      distinctUntilChanged(
        (a, b) => a.clienteId === b.clienteId
      ),

      switchMap(() =>
        this.moduloService.getAllModuloTransparencia().pipe(
          map(res => res.data)
        )
      ),

      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  getModulos(): Observable<ModuloResponse[]> {
    return this.modulos$;
  }
}
